<template>
  <div>
    <NavbarSpmi />
    <main class="p-4">
        {{ $route.params.id }}
      <!-- <router-view :key="$route.fullPath" /> -->
    </main>
  </div>
</template>

<script setup>
import NavbarSpmi from '@/components/spmi/NavbarSpmi.vue'
</script>
